// Class: openfl.display.Loader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $bind = require("./../../bind_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_display_DisplayObjectContainer() {return require("./../../openfl/display/DisplayObjectContainer");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_Error() {return require("./../../openfl/errors/Error");}
function openfl_utils__$internal_Lib() {return require("./../../openfl/utils/_internal/Lib");}
function openfl_events_Event() {return require("./../../openfl/events/Event");}
function openfl_Lib() {return require("./../../openfl/Lib");}
function StringTools() {return require("./../../StringTools");}
function openfl_utils_Assets() {return require("./../../openfl/utils/Assets");}
function openfl_events_IOErrorEvent() {return require("./../../openfl/events/IOErrorEvent");}
function Std() {return require("./../../Std");}
function openfl_events_ProgressEvent() {return require("./../../openfl/events/ProgressEvent");}
function HxOverrides() {return require("./../../HxOverrides");}
function openfl_display_LoaderInfo() {return require("./../../openfl/display/LoaderInfo");}
function openfl_display__$internal_BitmapDataLoader() {return require("./../../openfl/display/_internal/BitmapDataLoader");}
function openfl_display__$internal_ScriptLoader() {return require("./../../openfl/display/_internal/ScriptLoader");}
function openfl_display__$internal_AssetManifestLoader() {return require("./../../openfl/display/_internal/AssetManifestLoader");}

// Constructor

var Loader = function() {
	(openfl_display_DisplayObjectContainer().default).call(this);
	this.__drawableType = 4;
	this.contentLoaderInfo = (openfl_display_LoaderInfo().default).create(this);
	this.uncaughtErrorEvents = this.contentLoaderInfo.uncaughtErrorEvents;
	this.__unloaded = true;
}

// Meta

Loader.__name__ = "openfl.display.Loader";
Loader.__isInterface__ = false;
Loader.__super__ = (openfl_display_DisplayObjectContainer().default);
Loader.prototype = $extend((openfl_display_DisplayObjectContainer().default).prototype, {
	addChild: function(child) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("Error #2069: The Loader class does not implement this method.",2069));
	},
	addChildAt: function(child,index) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("Error #2069: The Loader class does not implement this method.",2069));
	},
	close: function() {
		(openfl_utils__$internal_Lib().default).notImplemented({ fileName : "../node_modules/openfl-haxelib/src/openfl/display/Loader.hx", lineNumber : 240, className : "openfl.display.Loader", methodName : "close"});
	},
	load: function(request,context) {
		this.unload();
		var openEvent = new (openfl_events_Event().default)("open");
		this.contentLoaderInfo.dispatchEvent(openEvent);
		this.contentLoaderInfo.loaderURL = (openfl_Lib().default).get_current().get_loaderInfo().url;
		this.contentLoaderInfo.url = request.url;
		this.__unloaded = false;
		if(request.contentType == null || request.contentType == "") {
			var extension = "";
			var path = request.url;
			var queryIndex = path.indexOf("?");
			if(queryIndex > -1) {
				path = path.substring(0,queryIndex);
			}
			while((StringTools().default).endsWith(path,"/")) path = path.substring(0,path.length - 1);
			if((StringTools().default).endsWith(path,".bundle")) {
				path += "/library.json";
				if(queryIndex > -1) {
					request.url = path + request.url.substring(queryIndex);
				} else {
					request.url = path;
				}
			}
			var extIndex = path.lastIndexOf(".");
			if(extIndex > -1) {
				extension = path.substring(extIndex + 1);
			}
			var tmp;
			switch(extension) {
			case "gif":
				tmp = "image/gif";
				break;
			case "jpeg":case "jpg":
				tmp = "image/jpeg";
				break;
			case "js":
				tmp = "application/javascript";
				break;
			case "json":
				tmp = "application/json";
				break;
			case "png":
				tmp = "image/png";
				break;
			case "swf":
				tmp = "application/x-shockwave-flash";
				break;
			default:
				tmp = "application/x-www-form-urlencoded";
			}
			this.contentLoaderInfo.contentType = tmp;
		} else {
			this.contentLoaderInfo.contentType = request.contentType;
		}
		var future = null;
		var i = Loader.__registeredLoaders.length;
		var loader = null;
		while(i > 0) {
			--i;
			loader = Loader.__registeredLoaders[i];
			future = loader.load(request,context,this.contentLoaderInfo);
			if(future != null) {
				break;
			}
		}
		if(future != null) {
			future.onComplete($bind(this,this.Loader_onComplete));
			future.onProgress($bind(this,this.Loader_onProgress));
			future.onError($bind(this,this.Loader_onError));
		} else {
			this.__dispatchError("No DisplayObject loader found");
		}
	},
	loadBytes: function(buffer,context) {
		var future = null;
		var i = Loader.__registeredLoaders.length;
		var loader = null;
		while(i > 0) {
			--i;
			loader = Loader.__registeredLoaders[i];
			future = loader.loadBytes(buffer,context,this.contentLoaderInfo);
			if(future != null) {
				break;
			}
		}
		if(future != null) {
			future.onComplete($bind(this,this.Loader_onComplete));
			future.onProgress($bind(this,this.Loader_onProgress));
			future.onError($bind(this,this.Loader_onError));
		} else {
			this.__dispatchError("No DisplayObject loader found");
		}
	},
	removeChild: function(child) {
		if(child == this.content) {
			return (openfl_display_DisplayObjectContainer().default).prototype.removeChild.call(this,this.content);
		} else {
			throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("Error #2069: The Loader class does not implement this method.",2069));
		}
	},
	removeChildAt: function(index) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("Error #2069: The Loader class does not implement this method.",2069));
	},
	setChildIndex: function(child,index) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_Error().default)("Error #2069: The Loader class does not implement this method.",2069));
	},
	unload: function() {
		if(!this.__unloaded) {
			if(this.content != null && this.content.parent == this) {
				(openfl_display_DisplayObjectContainer().default).prototype.removeChild.call(this,this.content);
			}
			if(this.__library != null) {
				(openfl_utils_Assets().default).unloadLibrary(this.contentLoaderInfo.url);
				this.__library = null;
			}
			this.content = null;
			this.contentLoaderInfo.url = null;
			this.contentLoaderInfo.contentType = null;
			this.contentLoaderInfo.content = null;
			this.contentLoaderInfo.bytesLoaded = 0;
			this.contentLoaderInfo.bytesTotal = 0;
			this.contentLoaderInfo.width = 0;
			this.contentLoaderInfo.height = 0;
			this.__unloaded = true;
			this.contentLoaderInfo.dispatchEvent(new (openfl_events_Event().default)("unload"));
		}
	},
	unloadAndStop: function(gc) {
		if(gc == null) {
			gc = true;
		}
		if(this.content != null) {
			this.content.__stopAllMovieClips();
		}
		var _g = 0;
		var _g1 = this.get_numChildren();
		while(_g < _g1) {
			var i = _g++;
			this.getChildAt(i).__stopAllMovieClips();
		}
		this.unload();
		var gc1 = gc;
	},
	__dispatchError: function(error) {
		if(((error) instanceof (openfl_events_Event().default))) {
			this.contentLoaderInfo.dispatchEvent(error);
		} else {
			var event = new (openfl_events_IOErrorEvent().default)("ioError");
			event.text = (Std().default).string(error);
			this.contentLoaderInfo.dispatchEvent(event);
		}
	},
	Loader_onComplete: function(content) {
		if(content == null) {
			this.__dispatchError("Unknown error");
			return;
		}
		this.content = content;
		this.contentLoaderInfo.content = content;
		if(this.contentLoaderInfo.width == -1 || this.contentLoaderInfo.height == -1) {
			var tmp = content.get_width();
			this.contentLoaderInfo.width = (Std().default).int(tmp);
			var tmp1 = content.get_height();
			this.contentLoaderInfo.height = (Std().default).int(tmp1);
		}
		(openfl_display_DisplayObjectContainer().default).prototype.addChildAt.call(this,content,0);
		this.contentLoaderInfo.dispatchEvent(new (openfl_events_Event().default)("complete"));
	},
	Loader_onError: function(error) {
		this.__dispatchError(error);
	},
	Loader_onProgress: function(bytesLoaded,bytesTotal) {
		var event = new (openfl_events_ProgressEvent().default)("progress");
		event.bytesLoaded = bytesLoaded;
		event.bytesTotal = bytesTotal;
		this.contentLoaderInfo.dispatchEvent(event);
	}
});
Loader.prototype.__class__ = Loader.prototype.constructor = $hxClasses["openfl.display.Loader"] = Loader;

// Init

{
	var loaders = [new (openfl_display__$internal_BitmapDataLoader().default)(),new (openfl_display__$internal_ScriptLoader().default)(),new (openfl_display__$internal_AssetManifestLoader().default)()];
	if(Loader.__registeredLoaders == null) {
		Loader.__registeredLoaders = loaders;
	} else {
		Loader.__registeredLoaders = loaders.concat(Loader.__registeredLoaders);
	}
};

// Statics

Loader.registerLoader = function(loader) {
	if(loader == null) {
		return;
	}
	if(Loader.__registeredLoaders == null) {
		Loader.__registeredLoaders = [];
	}
	(HxOverrides().default).remove(Loader.__registeredLoaders,loader);
	Loader.__registeredLoaders.push(loader);
}
Loader.__meta__ = { fields : { __dispatchError : { SuppressWarnings : ["checkstyle:Dynamic"]}, Loader_onError : { SuppressWarnings : ["checkstyle:Dynamic"]}}}

// Export

exports.default = Loader;